<div class="flex flex-col gap-2" style="height: 80vh">
    @if (rawUrl) {
        <div class="flex flex-wrap items-center gap-3 text-sm text-gray-600">
            <a [href]="rawUrl" target="_blank" rel="noopener noreferrer" class="text-primary underline">
                Open in new tab
            </a>
            <span class="text-xs text-gray-400">
                If preview is blank, the browser may be downloading the file instead — use the link above.
            </span>
        </div>
    }
    @if (pdfUrl) {
        <iframe title="Document preview"
                [src]="pdfUrl"
                style="width:100%; flex:1; min-height:60vh; border:none;">
        </iframe>
    }
</div>
